"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.compareAccounts = exports.planDisplayName = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const Dns_1 = __importDefault(require("@mui/icons-material/Dns"));
const ArrowDropDown_1 = __importDefault(require("@mui/icons-material/ArrowDropDown"));
const Payment_1 = __importDefault(require("@mui/icons-material/Payment"));
const Avatar_1 = __importDefault(require("@mui/material/Avatar"));
const Box_1 = __importDefault(require("@mui/material/Box"));
const Button_1 = __importDefault(require("@mui/material/Button"));
const Stack_1 = __importDefault(require("@mui/material/Stack"));
const Popover_1 = __importDefault(require("@mui/material/Popover"));
const LinkContext_1 = require("./LinkContext");
const icons_material_1 = require("@mui/icons-material");
function AccountSwitcher({ user, activeAccount, popoverProps, buttonProps, }) {
    const anchorRef = (0, react_1.useRef)();
    const [open, setOpen] = (0, react_1.useState)(false);
    if (!user) {
        return null;
    }
    const avatar = ((0, jsx_runtime_1.jsx)(Avatar_1.default, { sx: { width: "32px", height: "32px" }, src: user.picture, imgProps: { referrerPolicy: "no-referrer" } }));
    const arrow = ((0, jsx_runtime_1.jsx)(ArrowDropDown_1.default, { sx: {
            transform: open ? "rotate(180deg)" : undefined,
            color: "text.secondary",
        } }));
    let anchor;
    if (activeAccount) {
        anchor = ((0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ ref: anchorRef }, buttonProps, { onClick: (...args) => {
                var _a;
                (_a = buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.onClick) === null || _a === void 0 ? void 0 : _a.call(buttonProps, ...args);
                setOpen(!open);
            } }, { children: (0, jsx_runtime_1.jsxs)(Stack_1.default, Object.assign({ direction: "row", spacing: 2, sx: {
                    width: "100%",
                    alignItems: "center",
                    px: "1ch",
                    overflow: "hidden",
                } }, { children: [avatar, (0, jsx_runtime_1.jsx)(AccountSummary, { sx: { lineHeight: "1.2em", flexShrink: 1 }, account: activeAccount, isActive: true }), arrow] })) })));
    }
    else {
        anchor = ((0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ ref: anchorRef, onClick: () => setOpen(!open) }, { children: avatar })));
    }
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [anchor, (0, jsx_runtime_1.jsx)(AccountSwitcherPopover, Object.assign({ open: open, onClose: () => setOpen(false), anchor: anchorRef, activeAccount: activeAccount }, popoverProps))] }));
}
exports.default = AccountSwitcher;
const borderStyle = "1px solid rgb(90% 90% 90%)";
function AccountSwitcherPopover({ open, anchor, accounts, activeAccount, accountInfo, onClose, onLogOut, onManageAccount, onChangeAccount, onNewAccount, onOpenCookieSettings, }) {
    const LinkComponent = (0, LinkContext_1.useLink)();
    if (!(anchor === null || anchor === void 0 ? void 0 : anchor.current)) {
        return null;
    }
    const otherAccounts = (accounts || [])
        .filter((a) => a.name != (activeAccount === null || activeAccount === void 0 ? void 0 : activeAccount.name))
        .sort(compareAccounts);
    let otherAccountsLabel = activeAccount ? "Other Accounts" : "Accounts";
    if (otherAccounts.length == 0) {
        if (!(accounts === null || accounts === void 0 ? void 0 : accounts.length)) {
            otherAccountsLabel = "Your are not a member of any accounts";
        }
        else {
            otherAccountsLabel = "Your are not a member of any other accounts";
        }
    }
    return ((0, jsx_runtime_1.jsxs)(Popover_1.default, Object.assign({ open: open, onClose: onClose, anchorEl: anchor === null || anchor === void 0 ? void 0 : anchor.current, anchorOrigin: {
            vertical: "top",
            horizontal: "right",
        }, transformOrigin: {
            vertical: "top",
            horizontal: "right",
        }, sx: {
            overflow: "hidden",
        }, PaperProps: {
            sx: {
                overflow: "hidden",
                maxHeight: "max(95vh, 30rem)",
                display: "grid",
                width: "400px",
                gridTemplateRows: "auto auto 1fr",
                "& > *": {
                    borderBottom: borderStyle,
                },
                "& > :last-child": {
                    borderBottom: "none",
                },
            },
        } }, { children: [(0, jsx_runtime_1.jsx)(Box_1.default, { children: activeAccount && ((0, jsx_runtime_1.jsx)(AccountDetails, { account: activeAccount, accountInfo: accountInfo, onManageAccount: () => {
                        onManageAccount === null || onManageAccount === void 0 ? void 0 : onManageAccount();
                        onClose === null || onClose === void 0 ? void 0 : onClose();
                    } })) }), (0, jsx_runtime_1.jsx)(Box_1.default, Object.assign({ sx: {
                    fontWeight: "600",
                    fontSize: "90%",
                    color: "text.secondary",
                    bgcolor: "background.default",
                    padding: 1,
                } }, { children: (0, jsx_runtime_1.jsx)("span", { children: otherAccountsLabel }) })), (0, jsx_runtime_1.jsx)(Box_1.default, Object.assign({ sx: {
                    display: "grid",
                    overflowY: "auto",
                } }, { children: otherAccounts === null || otherAccounts === void 0 ? void 0 : otherAccounts.map((acc, i) => ((0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ component: LinkComponent, href: `/${acc.name}`, sx: {
                        borderBottom: i == otherAccounts.length - 1 ? undefined : borderStyle,
                        justifyContent: "stretch",
                    }, onClick: () => onChangeAccount === null || onChangeAccount === void 0 ? void 0 : onChangeAccount(acc) }, { children: (0, jsx_runtime_1.jsx)(AccountSummary, { account: acc, isActive: false }) }), acc.name))) })), onNewAccount ? ((0, jsx_runtime_1.jsx)(Box_1.default, Object.assign({ sx: { padding: 1 } }, { children: (0, jsx_runtime_1.jsxs)(Button_1.default, Object.assign({ fullWidth: true, variant: "contained", color: "secondary", sx: {
                        display: "flex",
                        gap: "1ch",
                        fontWeight: "500",
                        border: borderStyle,
                    }, onClick: () => {
                        onClose === null || onClose === void 0 ? void 0 : onClose();
                        onNewAccount();
                    } }, { children: [(0, jsx_runtime_1.jsx)(icons_material_1.Add, {}), " New Account"] })) }))) : null, onLogOut ? ((0, jsx_runtime_1.jsx)(Box_1.default, Object.assign({ sx: { padding: 1 } }, { children: (0, jsx_runtime_1.jsxs)(Button_1.default, Object.assign({ fullWidth: true, variant: "contained", sx: {
                        display: "flex",
                        gap: "1ch",
                        fontWeight: "500",
                        border: borderStyle,
                    }, onClick: () => {
                        onClose === null || onClose === void 0 ? void 0 : onClose();
                        onLogOut();
                    } }, { children: [(0, jsx_runtime_1.jsx)(icons_material_1.Logout, {}), " Sign Out"] })) }))) : null, onOpenCookieSettings ? ((0, jsx_runtime_1.jsx)(Box_1.default, Object.assign({ sx: {
                    display: "flex",
                    justifyContent: "right",
                } }, { children: (0, jsx_runtime_1.jsxs)(Button_1.default, Object.assign({ variant: "text", color: "secondary", sx: {
                        display: "flex",
                        gap: "0.8ch",
                        fontWeight: "500",
                        fontSize: "0.75rem",
                        color: "text.secondary",
                    }, onClick: () => {
                        onClose === null || onClose === void 0 ? void 0 : onClose();
                        onOpenCookieSettings();
                    } }, { children: [(0, jsx_runtime_1.jsx)(icons_material_1.Cookie, { sx: { fontSize: "1rem" } }), "Cookies"] })) }))) : null] })));
}
function AccountDetails({ account, accountInfo, onManageAccount }) {
    const LinkComponent = (0, LinkContext_1.useLink)();
    return ((0, jsx_runtime_1.jsxs)(Stack_1.default, Object.assign({ sx: { alignItems: "flex-start", minWidth: "400px", padding: 1 } }, { children: [(0, jsx_runtime_1.jsx)(Box_1.default, Object.assign({ sx: { fontWeight: "600" } }, { children: account === null || account === void 0 ? void 0 : account.display_name })), (0, jsx_runtime_1.jsx)(Box_1.default, Object.assign({ sx: { color: "text.secondary" } }, { children: (0, jsx_runtime_1.jsx)("pre", Object.assign({ style: { margin: 0, whiteSpace: "pre-wrap" } }, { children: (0, jsx_runtime_1.jsx)("code", { children: account === null || account === void 0 ? void 0 : account.name }) })) })), (0, jsx_runtime_1.jsx)(IconBullet, { sx: { marginTop: 1 }, icon: (0, jsx_runtime_1.jsx)(Dns_1.default, {}), text: "Cloud Region", secondaryText: account === null || account === void 0 ? void 0 : account.region }), (0, jsx_runtime_1.jsx)(IconBullet, { sx: { marginTop: 1 }, icon: (0, jsx_runtime_1.jsx)(Payment_1.default, {}), text: "Plan", secondaryText: planDisplayName(accountInfo === null || accountInfo === void 0 ? void 0 : accountInfo.subscription.plan_id) }), (0, jsx_runtime_1.jsx)(Stack_1.default, Object.assign({ direction: "row", justifyContent: "stretch", alignSelf: "stretch", alignItems: "center", spacing: 1, marginTop: 1 }, { children: (0, jsx_runtime_1.jsxs)(Button_1.default, Object.assign({ variant: "contained", component: LinkComponent, href: `/${account.name}/account`, color: "secondary", sx: {
                        display: "flex",
                        gap: "1ch",
                        fontWeight: "500",
                        width: "100%",
                        border: "1px solid rgb(90% 90% 90%)",
                    }, onClick: (e) => {
                        if (onManageAccount) {
                            e.preventDefault();
                            onManageAccount();
                        }
                    } }, { children: [(0, jsx_runtime_1.jsx)(icons_material_1.Settings, {}), " Manage Account"] })) }))] })));
}
function IconBullet({ sx, icon, text, secondaryText }) {
    return ((0, jsx_runtime_1.jsxs)(Stack_1.default, Object.assign({ direction: "row", sx: Object.assign({ justifyContent: "flex-start", alignItems: "center" }, sx) }, { children: [(0, jsx_runtime_1.jsx)(Box_1.default, Object.assign({ sx: { padding: 1, paddingRight: 2 } }, { children: icon })), (0, jsx_runtime_1.jsxs)(Stack_1.default, Object.assign({ sx: { alignItems: "flex-start", justifyContent: "center" } }, { children: [(0, jsx_runtime_1.jsx)(Box_1.default, Object.assign({ sx: { fontWeight: "500" } }, { children: text })), secondaryText ? ((0, jsx_runtime_1.jsx)(Box_1.default, Object.assign({ sx: { color: "text.secondary" } }, { children: secondaryText }))) : null] }))] })));
}
function AccountSummary({ sx, account, isActive }) {
    return ((0, jsx_runtime_1.jsxs)(Stack_1.default, Object.assign({ sx: Object.assign({ maxWidth: "100%", alignItems: "flex-start", paddingX: 1 }, sx) }, { children: [(0, jsx_runtime_1.jsx)(Box_1.default, Object.assign({ sx: {
                    maxWidth: "100%",
                    fontWeight: isActive ? "500" : undefined,
                    fontSize: "110%",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                } }, { children: account.display_name })), (0, jsx_runtime_1.jsx)(Box_1.default, Object.assign({ sx: { color: "text.secondary" } }, { children: account === null || account === void 0 ? void 0 : account.region }))] })));
}
function planDisplayName(plan_id) {
    switch (plan_id) {
        case "free":
            return "Developer";
        case "on_demand":
            return "Team";
        case "enterprise":
            return "Enterprise";
        case "internal_test":
            return "Internal Test";
        default:
            return plan_id;
    }
}
exports.planDisplayName = planDisplayName;
function compareAccounts(a, b) {
    var _a, _b;
    // We generally sort by lower-cased display name, but break ties by case-sensitive match,
    // and finally by the region name. So the sort keys are these tokens separated by the nul char.
    const nul = "\u0000";
    const aKey = `${(_a = a.display_name) === null || _a === void 0 ? void 0 : _a.toLowerCase()}${nul}${a.display_name}${nul}${a === null || a === void 0 ? void 0 : a.region}`;
    const bKey = `${(_b = b.display_name) === null || _b === void 0 ? void 0 : _b.toLowerCase()}${nul}${b.display_name}${nul}${b === null || b === void 0 ? void 0 : b.region}`;
    if (aKey < bKey) {
        return -1;
    }
    if (aKey > bKey) {
        return 1;
    }
    return 0;
}
exports.compareAccounts = compareAccounts;
